const createAppUrl = (path: string) => {
    const noSlashPath = path.replace(/^\/+/, ""); // replace first characters of path if slashes
    return `${window.location.protocol}//${window.location.host}/${noSlashPath}`;
};

export { createAppUrl };
